import './index.scss';
import React, { Suspense, useEffect } from 'react';
import { Outlet }                     from 'react-router-dom';
import { Sider }                      from '../../components/layout';
import Menu                           from '../../components/menu';
import LayoutHeader                   from './header';
import { userInfoStore }              from '../../models';
import { Breadcrumb }                 from '../../components/breadcrumb';

const MainLayout = () => {
  useEffect(() => {
    if (!userInfoStore.StaffId) {
      userInfoStore.requestUserInfo();
    }
  }, []);

  return (
    <div className='main_layout'>
      <LayoutHeader />
      <div className='body_bar'>
        <Sider collapsible={true}>
          <Menu />
        </Sider>
        <div className='content_bar flex flex-column'>
          <Breadcrumb />
          <div className="suspense-layer">
            <Suspense>
              <Outlet />
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
